import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import minMax from "dayjs/plugin/minMax";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { fixedOffsetZones } from "./fixedOffsetZones";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(fixedOffsetZones); // Wraps `tz()`, so it must come after `timezone`
dayjs.extend(advancedFormat); // Required for formatting timezone names to abbr.
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(localeData);
dayjs.extend(duration);
dayjs.extend(minMax);
